export const LATEST_RATE_SHEET = {
  title: "Mortgage rates PDF (859KB 19.05.2025)",
  href: "/ratesheet/20250519-Rate-Sheet.pdf",
  date: "19.05.2025",
};
